import React, { useEffect, useLayoutEffect, useMemo, useRef, useState, useCallback } from 'react';
import { loadThreads, getChatHistorybyOrgUser } from '../utils/botFactoryAPI';
import ReactDOMServer from 'react-dom/server';
//Heroicons
import * as HeroSolid from '@heroicons/react/24/solid';
import * as HeroOutline from '@heroicons/react/24/outline';
import { MicIcon, MicBlockedIcon, SpeakerIcon, SpeakerOffIcon, ArrowUpIcon } from './icons/VoiceBarIcons';
import './VoiceBar.scss';
import { isLightColor } from '../utils/colorContrast';

import { logRelay } from '../utils/client-logger';
import { isSessionExpiredLocked } from '../modules/sessionExpiredUI';
import { resolveCommandFromInput } from '../utils/resolveCommand';
import { buildContactEmail, contactEmailFailureText, pickAgentId } from '../utils/contactEmail';
import { getLanguageMode, setLanguageMode } from '../lib/languageMode';


// ⛔ REACT_APP_-prefixed or it is dead: CRA inlines nothing else. `EMAIL_BASE_URL` was
// never reaching the bundle, so v2 has been emailing through the LEGACY api all along —
// silent, because a working legacy endpoint looks exactly like success.
const EMAIL_BASE_URL =
  process.env.REACT_APP_EMAIL_BASE_URL ||
  'https://robot-api-37f87b97b291.herokuapp.com';

const DEFAULT_PROMPT_BUTTON_MAX = 12;

let filteredText ="";//emailed content is filtered
let filteredHTML =""; 

//Get user
  const storedUser =localStorage.getItem("user");
  const user = storedUser && storedUser !== "null" ? JSON.parse(storedUser) : { 
    id: "guest",
    username: "guest",
    email: "",
    firstname: "Guest",
    lastname: "User",
    emailVerified: false,
    verificationToken: "",
    role: "guest",
    mobile: "",
    pic: "",
    system: false,
  };

  /* GET ORG SETTING for SKIN - Default and Clone */
  let settings = null;
 
  try {
    const orgCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('org='))
      ?.split('=')[1];

    if (orgCookie) {
      settings = JSON.parse(decodeURIComponent(orgCookie));
    }
  } catch (err) {
    console.warn('❌ Failed to parse settings from org cookie:', err);
  }

const ChatUI = ({
  Header,
  Footer,
  iBots,
  assistantId,
  isConnected,
  timeLeft,
  connectConversation,
  setTimeLeft,
  sendTextQuery,
  isRecording,
  startRecording,
  stopRecording,
  clientCanvasRef,
  serverCanvasRef,
  items,
  setItems,
  clientRef,
  iBookThumbnail,
  showEventsLog,
  setShowEventsLog,
  eventsScrollRef,
  realtimeEvents,
  selectedBot,
  botSettings = null,
  clearSession,
  toggleMute = () => {},
  isMuted = false,
  micMode = 'hf',
  micBlocked = false,
  assistantSpeaking = false,
  inputLevelRef = { current: 0 },
  onRetryMic = () => {},
  interruptPlayback = () => {},
  onPromptClicked = (_prompt) => {},
  onUserQuestion = (_message) => {},
  onSessionCleared = (_reason) => {},
  stopButtonSendsStop = false,
  preservePromptMultiline = false,
  onLanguageCommand = (_lang) => {},

}) => {
  const userInputRef = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailTo, setEmailTo] = useState("");
  const [emailSubject, setEmailSubject] = useState("Conversation Content");
  const [emailBody, setEmailBody] = useState("");
  const [emailFrom, setEmailFrom] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [emailFromName, setEmailFromName] = useState(""); 
  const [emailToName, setEmailToName] = useState(""); 
 
  // PDF modal state (optional)
  const [pdfModalSrc, setPdfModalSrc] = useState(null);
  const [pdfModalTitle, setPdfModalTitle] = useState('');
  const [videoModalSrc, setVideoModalSrc] = useState(null);
  const [videoModalTitle, setVideoModalTitle] = useState('');

  const [threads, setThreads] = useState(null);// Threads list from botFactory API
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pttHolding, setPttHolding] = useState(false); // Push-to-Talk: finger or button is down right now
  const [inputLevel, setInputLevel] = useState(0); // mic input level for the bar, in tenths (0 to 1)
  const [hasText, setHasText] = useState(false); // the text input holds something to send
  const [convHeight, setConvHeight] = useState(null); // default height (px) of the conversation box so the toolbar sits 20px above the bottom of the screen
  const [micRenderKey, setMicRenderKey] = useState(0); // force re-mount after background resume
  const isRecordingRef = useRef(isRecording);
  const stopHandledRef = useRef(false);
  const wasRecordingOnHideRef = useRef(false);
  const micRestoreNeededRef = useRef(false); // track if mic should be re-primed after returning to foreground
  const micRestoreInFlightRef = useRef(false);

  // image icons
  const copyIconWhite = "/assets/app/copy-white.png"
  const storeIconWhite = "/assets/app/stop-white.png"
  const trashIconWhite = "/assets/app/trash-white.png"
  const emailIconBlack = "/assets/app/email-black.png"
  const emailIconWhite = "/assets/app/email-white.png"

  const statusThinking = "/assets/app/elipsis.gif"

  useEffect(() => {
    isRecordingRef.current = isRecording;
  }, [isRecording]);

  useEffect(() => {
    if (pdfModalSrc) {
      logRelay('[ChatUI][PDF] Modal src set:', pdfModalSrc, 'title:', pdfModalTitle);
    }
  }, [pdfModalSrc, pdfModalTitle]);

  useEffect(() => {
    const handleVideoModalClick = (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-video-modal-src]')
        : null;
      if (!trigger) return;

      event.preventDefault();
      const src = trigger.getAttribute('data-video-modal-src') || '';
      const title = trigger.getAttribute('data-video-modal-title') || 'Video';
      if (!src) return;

      setVideoModalSrc(src);
      setVideoModalTitle(title);
    };

    document.addEventListener('click', handleVideoModalClick);
    return () => {
      document.removeEventListener('click', handleVideoModalClick);
    };
  }, []);

  useEffect(() => {
    const handleQueryButtonClick = (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-query-text]')
        : null;
      if (!trigger) return;

      event.preventDefault();
      const queryText = trigger.getAttribute('data-query-text') || '';
      if (!queryText) return;

      triggerQueryThroughTextInput(queryText);
    };

    document.addEventListener('click', handleQueryButtonClick);
    return () => {
      document.removeEventListener('click', handleQueryButtonClick);
    };
  }, []);

  // Fallback: delegate click handler for any element carrying data-pdf-src
  useEffect(() => {
    const handler = (e) => {
      const target = e.target;
      if (!target || !(target instanceof HTMLElement)) return;
      const pdfEl = target.closest('[data-pdf-src]');
      if (!pdfEl) return;
      const url = pdfEl.getAttribute('data-pdf-src');
      const title = pdfEl.getAttribute('data-pdf-title') || 'PDF Document';
      if (!url) return;
      logRelay('[ChatUI][PDF] Delegate click open modal for', url);
      e.preventDefault();
      setPdfModalSrc(url);
      setPdfModalTitle(title);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  //Stop bot Speech on Video Render
  const stopSentRef = useRef(false);

  // Track SAY media that have already been triggered to avoid duplicate playback
  const sayTriggeredRef = useRef(new Set());
  const autoOpenedVideoRef = useRef(new Set());
  const sayResponseInFlightRef = useRef(false);
  const checkedCommandItemIdsRef = useRef(new Set());

  // Reset SAY tracking when bot changes (not on every items update)
  // Fix for fast machine
  useEffect(() => {
    sayTriggeredRef.current.clear();
    autoOpenedVideoRef.current.clear();
  }, [selectedBot?.botid]);
  useEffect(() => {
    window.clearSayInFlight = () => {
      sayResponseInFlightRef.current = false;
      window.saySuppressActive = false;
    };
    return () => { delete window.clearSayInFlight; };
  }, []);

  //const renderedMediaKeys = new Set();   // ✅ Track [Media] keys globally to force single render

  const [emailBodyHTML, setEmailBodyHTML] = useState("");// Email editing

  let userInLineName = null;

  const notifySessionCleared = (reason = 'user_stop') => {
    if (typeof onSessionCleared === 'function' && onSessionCleared !== clearSession) {
      onSessionCleared(reason);
    }
  };

  const defaultBotSettings = useMemo(() => ({
    integration: {
      EmailConfig: {
        from_email: '',
        from_name: '',
        to_email: '',
        to_name: '',
        emailMessage: ''
      },
    },
    creator: { name: '', url: '' },
    logo: '',
    containerStyle: {
      copyContentButton: 'false',
      deleteContentButton: 'false',
      emailContentButton: 'false',
    },
  }), []);

  const [selectedBotSettings, setSelectedBotSettings] = useState(defaultBotSettings);

  useEffect(() => {
    const mergeWithDefaults = (settings = {}) => {
      const integration = {
        ...defaultBotSettings.integration,
        ...(settings.integration || {}),
        EmailConfig: {
          ...defaultBotSettings.integration.EmailConfig,
          ...(settings.integration && settings.integration.EmailConfig ? settings.integration.EmailConfig : {}),
        },
      };

      return {
        ...defaultBotSettings,
        ...settings,
        integration,
        creator: {
          ...defaultBotSettings.creator,
          ...(settings.creator || {}),
        },
        containerStyle: {
          ...defaultBotSettings.containerStyle,
          ...(settings.containerStyle || {}),
        },
      };
    };

    const ensureMatch = (settings) => {
      if (!settings) return null;
      const candidate = mergeWithDefaults(settings);
      if (!selectedBot?.botid) return candidate;
      return candidate.botid === selectedBot.botid ? candidate : null;
    };

    let resolved = ensureMatch(botSettings);

    if (!resolved) {
      try {
        const stored = localStorage.getItem('botSettings');
        if (stored) {
          resolved = ensureMatch(JSON.parse(stored));
        }
      } catch (err) {
        console.warn('[ChatUI] Failed to parse bot settings from storage:', err);
      }
    }

    if (!resolved) {
      try {
        const cookieValue = document.cookie
          .split('; ')
          .find((row) => row.startsWith('botSettings='))
          ?.split('=')[1];
        if (cookieValue) {
          resolved = ensureMatch(JSON.parse(decodeURIComponent(cookieValue)));
        }
      } catch (err) {
        console.warn('[ChatUI] Failed to parse bot settings from cookie:', err);
      }
    }

    if (!resolved && selectedBot?.integration?.EmailConfig) {
      resolved = mergeWithDefaults({
        botid: selectedBot.botid,
        name: selectedBot.title || '',
        logo: selectedBot.thumbnail || defaultBotSettings.logo,
        integration: {
          EmailConfig: {
            ...selectedBot.integration.EmailConfig,
          },
        },
        containerStyle: selectedBot.settings?.containerStyle || {},
      });
    } else if (!resolved && selectedBot) {
      resolved = mergeWithDefaults({
        botid: selectedBot.botid,
        name: selectedBot.title || '',
        logo: selectedBot.thumbnail || defaultBotSettings.logo,
        containerStyle: selectedBot.settings?.containerStyle || {},
      });
    }

    if (!resolved) {
      resolved = defaultBotSettings;
    }

    setSelectedBotSettings((prev) => {
      try {
        const prevString = JSON.stringify(prev);
        const nextString = JSON.stringify(resolved);
        if (prevString === nextString) {
          return prev;
        }
      } catch (err) {
        console.warn('[ChatUI] Failed to compare bot settings:', err);
      }
      return resolved;
    });
  }, [botSettings, selectedBot, defaultBotSettings]);

  useEffect(() => {
    if (selectedBotSettings) {
      logRelay('Bot Settings:', selectedBotSettings);
    }
  }, [selectedBotSettings?.botid]);

  // Voice command watcher — checks new user items from audio transcription
  // Only fires on role:'user' items; assistant items are never checked
  useEffect(() => {
    if (!items?.length || !selectedBot?.media) return;

    const lastUserItem = [...items].reverse().find(
      (item) => item.role === 'user' && (item.formatted?.text || item.formatted?.transcript),
    );
    if (!lastUserItem) return;

    const itemId = lastUserItem.id ?? lastUserItem.formatted?.text ?? '';
    if (!itemId || checkedCommandItemIdsRef.current.has(itemId)) return;
    checkedCommandItemIdsRef.current.add(itemId);

    const text = lastUserItem.formatted?.text || lastUserItem.formatted?.transcript || '';
    const cmd = resolveCommandFromInput(text, selectedBot);
    if (cmd?.type === 'lang') {
      // Guard: skip if already in this language — prevents loop on historical items
      if (cmd.lang === getLanguageMode(selectedBot?.botid)) return;
      logRelay(`[ChatUI][Command][Voice] Language command matched: ${cmd.key} → ${cmd.lang}`);
      if (onLanguageCommand) {
        onLanguageCommand(cmd.lang);
      } else {
        setLanguageMode(selectedBot?.botid, cmd.lang);
        window.location.reload();
      }
    }
  }, [items]);

  //close Modal and Reinstate Session
  const handleEmailCloseModal = async () => {
    setShowEmailModal(false);
    await handleResumeClick(); // Reinstate bot session
  };

  // State for Category and Sub-Category and Cards
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const videoContainerRef = useRef(null); 

  const triggerQueryThroughTextInput = (queryText) => {
    const trimmed = (queryText || '').toString().trim();
    if (!trimmed) return;

    const fullQuery = `Using your uploaded files only, search your knowledge files for ${trimmed}. Do not use general knowledge. If the files do not contain the exact answer, say so explicitly.`;
    const inputElement = document.getElementById('user-input');
    const submitButton = document.getElementById('submit-text');

    if (!inputElement || !submitButton) {
      console.warn('[ChatUI][QUERY] Missing user-input or submit-text element');
      return;
    }

    inputElement.value = fullQuery;
    submitButton.click();
  };
  
  // message:   the text shown in the UI / input field (translated in non-English mode).
  // aiMessage: the original English canonical key — used ONLY in English mode so the
  //            model can reliably match canonical topics and fire media tags.
  //
  // In non-English mode we send `message` (the translated text) to the relay so the
  // model stays in the target language. The session.update instructions already list
  // all English media key tokens verbatim, so the model can still emit the correct
  // English media token even when the input is in another language.
  // effectiveBot._currentLanguage is set by IndexPageGuest.tsx to reflect the active mode.
  const handleCardActivate = (message, aiMessage) => {
    console.log(`[ChatUI][card] handleCardActivate | msg="${(message||'').slice(0,60)}" | aiMsg="${(aiMessage||'').slice(0,60)}"`);
    const isNonEnglish = selectedBot?._currentLanguage && selectedBot._currentLanguage !== 'English';
    // message:   the text shown in the UI / input field (translated in non-English mode).
    // aiMessage: the original English canonical key — used so the model can reliably
    //            match canonical topics and fire media tags.
    const displayText = (message || '').toString().trim();
    const originalText = (aiMessage || message || '').toString().trim();

    onPromptClicked?.(displayText);
    const inputElement = document.getElementById("user-input");
    if (inputElement) {
      inputElement.value = displayText;
    }

    // Command intercept — fires and reloads; never reaches relay
    if (tryHandleCommandMedia(originalText)) {
      if (inputElement) inputElement.value = '';
      return;
    }

    const queryEntry = selectedBot?.media?.[originalText];
    if (queryEntry?.type === 'query') {
      triggerQueryThroughTextInput(queryEntry.query || originalText);
      if (inputElement) inputElement.value = '';
      return;
    }

    // Intercept speech media here too
    if (!tryHandleSpeechMedia(originalText)) {
      // In non-English mode, send translated text for UI display but English for the AI.
      // IndexPageGuest's sendTextQuery handles this split if two arguments are provided.
      if (isNonEnglish) {
        console.log(`[ChatUI][card] → sendTextQuery (non-English) | display="${displayText?.slice(0,60)}" | relay="${originalText?.slice(0,60)}"`);
        sendTextQuery(displayText, originalText);
      } else {
        console.log(`[ChatUI][card] → sendTextQuery | text="${originalText?.slice(0,60)}"`);
        sendTextQuery(originalText);
      }
    }
    // Clear input field — speech media path doesn't go through sendTextQuery
    if (inputElement) inputElement.value = '';
    onUserQuestion?.(originalText, { fromPrompt: true });
  };

  const copyConversationContent = () => {
    const conversationElement = document.querySelector('.conversation');
    if (conversationElement) {
      const content = conversationElement.innerHTML; // Get HTML content
      logRelay('Copying content:', content);

      // Copy content to the clipboard
      const textToCopy = conversationElement.innerText || ''; // Convert HTML to plain text
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          alert('Conversation copied to clipboard!');
        })
        .catch((error) => {
          console.error('Failed to copy content to clipboard:', error);
        });

    } else {
      console.error('Conversation element not found!');
    }
  };

  const openEmailModal = () => {
       
      handleStopClick({ preserveConversation: true }); // ✅ Stop the bot session BEFORE opening the modal, but keep the conversation: a plain stop clears it and left an empty white box
      //client.close(); !! nope
      //const conversationElement = document.getElementById('conversation');

      const source = document.getElementById("conversation");
        if (!source) {
          alert("Conversation not found.");
          return;
        }

      const clone = source.cloneNode(true);
    
      //Filter and Remove content
      // [FIX] querySelector may return null; must call .remove() on the element, not its textContent
      const stopDiv = clone.querySelector("div.chat-text-item");
      if (stopDiv && stopDiv.textContent?.trim() === 'stop') {
        stopDiv.remove();
      }

      const firstDiv = clone.querySelector("div:nth-child(1)");
      if (firstDiv) firstDiv.remove();
   
      const secondDiv = clone.querySelector("div:nth-child(1)");
      if (secondDiv) secondDiv.remove();

      // The toolbar is NOT hidden here: nothing ever showed it again, so it vanished for good after the
      // modal closed. The modal's overlay already covers it while the modal is open.

      filteredText = clone.innerText.trim();
      
      if (filteredText ==='') {
        try {
          sessionStorage.setItem('metricsHold', '1');
          setTimeout(() => sessionStorage.removeItem('metricsHold'), 5000);
        } catch (err) {
          // ignore
        }
        alert("Conversation is empty. Cannot send an empty email.");
        return;
      }
      
      filteredHTML =  clone.innerHTML;
      logRelay('Email filtered text set');
      
      setEmailErrorMessage(""); // Clear any previous email errors
    
      // [FIX] setEmailFrom expects a string, not an object wrapper
      const escapedEmail = encodeURIComponent(emailFrom);
      setEmailFrom(escapedEmail);
     
      setEmailBody(clone.innerText || ""); // Populate email body with conversation

      setEmailTo("");
      const timestamp = new Date().toLocaleString();
      
      setEmailSubject(`Lead From ${selectedBot?.orgs?.[0]?.name || selectedBot?.name || ''} - ${selectedBot?.title} Conversation with ${user.firstname || userInLineName }  - ${timestamp}`);
      
      logRelay("✅  Email Modal Opened, showEmailModal:", showEmailModal);
      setShowEmailModal(true); // Open the email modal
    };

  const sendEmailContent = async () => {
  try {
    // 1️⃣ Basic Field Extraction
    const emailFrom = document.getElementById("emailFrom").value.trim();
    const emailFromName = document.getElementById("emailFromName").value.trim();
    const emailSubject = document.getElementById("emailSubject").value.trim();

    // 2️⃣ Get the editable “Your Message” box content
    const messageBox = document.querySelector('#emailBody div[contenteditable="true"]');
    const userMessage = messageBox ? messageBox.innerText.trim() : "";

    // 3️⃣ v2.07: botapi picks the recipient and sender from the bot's settings, so the request carries
    // only these six plain-text fields (anything else is a 422). See utils/contactEmail.js.
    const built = buildContactEmail({
      agentId: pickAgentId(selectedBot?.agentId, selectedBot?.id, selectedBot?.botid, assistantId),
      visitorName: emailFromName,
      visitorEmail: emailFrom,
      subject: emailSubject,
      message: userMessage,
      transcript: filteredText,
    });
    if (!built.ok) return alert(built.error);
    const emailData = built.payload;

    logRelay("📩 Sending Email Data:", emailData);

    // 4️⃣ Stop all bot activity per MSCB STOP rule, but keep the conversation on screen: a plain stop clears it,
    // and it stayed blank after the email until the bot spoke again.
    handleStopClick({ preserveConversation: true });

    // 5️⃣ Send via your API endpoint
    const response = await fetch(EMAIL_BASE_URL + "/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(emailData),
    });

    if (response.ok) {
      alert("✅ - Email sent successfully!");
      localStorage.removeItem("draftEmailMessage");
      handleEmailCloseModal();
    } else {
      const errText = await response.text();
      console.error("❌ Email failed:", response.status, errText);
      alert(contactEmailFailureText(response.status) || "Failed to send email.");
    }
  } catch (error) {
    console.error("❌ - Error sending email:", error);
    alert("An error occurred while sending the email.");
  }
};

  // const loadRun = async () => {
    //logRelay('🔚 - [loadRun] - Load a Run');
  //};
  
  //Handle Instant Stop
  const handleStopClick = async ({ preserveConversation = false } = {}) => {

  const client = clientRef?.current;

  logRelay(' ✅ Stop Client ref: ',client);
  if (!client) {
    console.warn('❌ [STOP] clientRef is not initialized.');
    return;
  }
  if (isSessionExpiredLocked()) {
    console.warn('[STOP] Session is expired; skipping reconnect/stop flow.');
    return;
  }

  logRelay('🛑 - End Session: Create.run');

  if (client.connectionState !== 'connected') {
    console.warn('[STOP] WebSocket not connected. Attempting reconnect...');
    try {
      await client.connect();
      logRelay('[STOP] WebSocket reconnected.');
    } catch (err) {
      console.warn('[STOP] Reconnect failed:', err.message);
    }
  }

  try {
    // Cancel if active; ignore errors when no active response
    try {
      client.cancelResponse(); 
    } catch (err) {
      // benign
    }
    client.sendUserMessageContent([{ type: 'input_text', text: 'stop' }]);
    logRelay('✅ [CHATUI STOP] STOP message sent.');

    if (!preserveConversation) {
      if (typeof clearSession === 'function') {
        await clearSession();
      }

      notifySessionCleared('user_stop');
    }

  } catch (err) {
    const errorMsg = err.message;
    const msg = 'Internet Connection Lost. Please try to reload your browser '+ errorMsg;
    alert(msg);
    logRelay(msg, errorMsg)
  }
};

  const formatLinks = (text) => {
    return text.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
  };

  // Intercept user text when it matches a command media tag; apply language — never sent to relay
  const tryHandleCommandMedia = (text) => {
    if (!text || !selectedBot?.media) return false;
    const cmd = resolveCommandFromInput(text, selectedBot);
    if (!cmd) return false;

    if (cmd.type === 'lang') {
      logRelay(`[ChatUI][Command] Language command matched: ${cmd.key} → ${cmd.lang}`);
      if (onLanguageCommand) {
        // Delegate to IndexPage — updates UI state + reconnects relay
        onLanguageCommand(cmd.lang);
      } else {
        // Fallback: direct cookie write + reload (no-prop legacy path)
        setLanguageMode(selectedBot?.botid, cmd.lang);
        window.location.reload();
      }
      return true;
    }

    return false;
  };

  // Intercept user text when it matches a speech-only media key; play it locally and skip server send
  const tryHandleSpeechMedia = (text) => {
    if (!text || !selectedBot?.media) return false;

    const mediaKeys = Object.keys(selectedBot.media);
    const matchKey = mediaKeys.find((key) => {
      const media = selectedBot.media[key];
      return (
        media?.type === 'speech' &&
        text.toLowerCase().includes(key.toLowerCase())
      );
    });

    if (!matchKey) return false;

    const media = selectedBot.media[matchKey];
    const sayText = media.say || media.text || '';
    if (!sayText) return false;

    // Guard: don't send the question if a previous SAY is still in flight,
    // otherwise orphan questions pile up without matching inject instructions.
    // Return true so handleCardActivate doesn't fall through to sendTextQuery.
    if (sayResponseInFlightRef.current) {
      console.warn('[ChatUI][SAY] Skipping; previous SAY still in flight.');
      return true;
    }

     // Send the user's question to the server as a conversation item so it stays in position.
    // This does NOT trigger a model response — only response.create does.
    const client = clientRef?.current;
    if (client?.realtime) {
      client.realtime.send('conversation.item.create', {
        item: {
          id: `say-question-${Date.now()}`,
          type: 'message',
          role: 'user',
          content: [{ type: 'input_text', text: text }]
        }
      });
    }


    // Trigger the scripted speech
    requestSaySpeech(sayText, matchKey);

    return true; // handled
  };

  const tryHandleVideoModalMedia = (text) => {
    if (!text || !selectedBot?.media) return false;

    const mediaKeys = Object.keys(selectedBot.media);
    const matchKey = mediaKeys.find((key) => {
      const media = selectedBot.media[key];
      const metadata = media?.metadata || '';
      const metadataHasModal = /(?:^|;)\s*modal\s*=\s*true\s*(?:;|$)/i.test(metadata);
      const openInModal = String(media?.modal || '').toLowerCase() === 'true' || metadataHasModal;
      const renderMatch = String(metadata).match(/(?:^|;)\s*render\s*=\s*['"]?([^;'"]+)['"]?\s*(?:;|$)/i);
      const launchMatch = String(metadata).match(/(?:^|;)\s*launch\s*=\s*['"]?([^;'"]+)['"]?\s*(?:;|$)/i);
      const renderMode = String(media?.render || renderMatch?.[1] || 'button').toLowerCase();
      const launchMode = String(media?.launch || launchMatch?.[1] || 'click').toLowerCase();
      const legacyAutoOpen =
        String(media?.autoOpenModal || media?.autoOpen || 'false').toLowerCase() === 'true';
      const shouldAutoLaunch = openInModal && renderMode !== 'button' && (launchMode === 'auto' || legacyAutoOpen);

      return (
        media?.type === 'video' &&
        text.toLowerCase().includes(key.toLowerCase())
      );
    });

    if (!matchKey) return false;

    const media = selectedBot.media[matchKey];
    const mediaSrc = media?.src || '';
    if (!mediaSrc) return false;

    const metadata = media?.metadata || '';
    const metadataHasModal = /(?:^|;)\s*modal\s*=\s*true\s*(?:;|$)/i.test(metadata);
    const openInModal = String(media?.modal || '').toLowerCase() === 'true' || metadataHasModal;
    const renderMatch = String(metadata).match(/(?:^|;)\s*render\s*=\s*['"]?([^;'"]+)['"]?\s*(?:;|$)/i);
    const launchMatch = String(metadata).match(/(?:^|;)\s*launch\s*=\s*['"]?([^;'"]+)['"]?\s*(?:;|$)/i);
    const renderMode = String(media?.render || renderMatch?.[1] || 'button').toLowerCase();
    const launchMode = String(media?.launch || launchMatch?.[1] || 'click').toLowerCase();
    const legacyAutoOpen =
      String(media?.autoOpenModal || media?.autoOpen || 'false').toLowerCase() === 'true';
    const shouldAutoLaunch = openInModal && renderMode !== 'button' && (launchMode === 'auto' || legacyAutoOpen);

    const titleMatch = String(media?.metadata || '').match(/(?:^|;)\s*title\s*=\s*['"]?([^;'"]+)['"]?\s*(?:;|$)/i);
    const title = titleMatch?.[1] || matchKey;

    if (shouldAutoLaunch) {
      onUserQuestion?.(text, { fromMedia: true, mediaType: 'video', launch: 'auto' });
      setItems((prevItems) => [
        ...prevItems,
        { role: 'user', formatted: { text } },
      ]);
      setVideoModalSrc(mediaSrc);
      setVideoModalTitle(title);
      return true;
    }

    onUserQuestion?.(text, { fromMedia: true, mediaType: 'video', launch: 'click' });
    setItems((prevItems) => [
      ...prevItems,
      { role: 'user', formatted: { text } },
      { role: 'assistant', formatted: { text: matchKey } },
    ]);
    return true;
  };

  const tryHandleLinkMedia = (text) => {
    if (!text || !selectedBot?.media) return false;

    const mediaKeys = Object.keys(selectedBot.media);
    const matchKey = mediaKeys.find((key) => {
      const media = selectedBot.media[key];
      return (
        (media?.type === 'link' || media?.type === 'imageLink') &&
        text.toLowerCase().includes(key.toLowerCase())
      );
    });

    if (!matchKey) return false;

    const media = selectedBot.media[matchKey];
    if (!media?.src && !media?.url) return false;

    onUserQuestion?.(text, { fromMedia: true, mediaType: media.type, launch: 'click' });
    setItems((prevItems) => [
      ...prevItems,
      { role: 'user', formatted: { text } },
      { role: 'assistant', formatted: { text: matchKey } },
    ]);
    return true;
  };

// Handle Resume (reinstate bot session)
const handleResumeClick = async () => {
  const client = clientRef?.current;

  if (!client) {
    console.warn('❌ [RESUME] clientRef not available.');
    return;
  }
  if (isSessionExpiredLocked()) {
    console.warn('[RESUME] Session is expired; skipping resume.');
    return;
  }

  try {
    if (client.connectionState !== 'connected') {
      logRelay('[RESUME] WebSocket not connected. Reconnecting...');
      await client.connect();
      logRelay('✅ [RESUME] WebSocket reconnected.');
    }

    // Send a "resume" or welcome message to restart flow
    client.sendUserMessageContent([{ type: 'input_text', text: 'resume' }]);
    logRelay('✅ [CHATUI RESUME] Resume message sent.');

  } catch (err) {
    console.warn('❌ [CHATUI RESUME] Failed to reinstate session:', err.message);
  }
};

  // Trigger realtime assistant to speak a supplied script (SAY media)
  const requestSaySpeech = async (sayText = '', label = 'say-media') => {
    if (!sayText) return false;
    if (isSessionExpiredLocked()) return false;

    // Avoid overlapping response.create calls that trigger server "active response" errors
    if (sayResponseInFlightRef.current) {
      console.warn('[ChatUI][SAY] Skipping request; previous SAY still in flight.');
      return false;
    }

    const client = clientRef?.current;
    const isRealtime = selectedBot?.endpoint?.includes('realtime');

    if (!isRealtime) {
      console.warn('[ChatUI][SAY] Skipping speech request: bot is not using a realtime endpoint.');
      return false;
    }

    if (!client || !client.realtime) {
      console.warn('[ChatUI][SAY] clientRef is not ready; cannot trigger speech.');
      return false;
    }

    try {
      if (!client.isConnected?.()) {
        if (typeof client.connect === 'function') {
          try {
            await client.connect();
          } catch (err) {
            console.warn('[ChatUI][SAY] connect failed:', err);
            return false;
          }
        }
      }

      // Stop any ongoing playback to keep the SAY audio clear
      if (typeof interruptPlayback === 'function') {
        try {
          await interruptPlayback();
        } catch (err) {
          console.warn('[ChatUI][SAY] interruptPlayback failed:', err);
        }
      }

        // Build strict verbatim instruction as a user turn.
        // instructions-only override on gpt-realtime is NOT strong enough — the model
        // still follows session instructions and adds greetings. We MUST inject a user
        // conversation item. The window.saySuppressActive flag tells conversation.updated
        // in IndexPageGuest to hide both this injected user item and the SAY response.
        const verbatimInstruction = [
          'READ THE FOLLOWING TEXT EXACTLY AS WRITTEN. Do not add any words before, after, or between.',
          'Do not greet. Do not introduce yourself. Do not acknowledge. Just read this text verbatim:',
          '',
          sayText
        ].join('\n');

        // Suppress ALL items created during SAY from the conversation UI
        // (the injected user instruction AND the assistant SAY response)
        window.saySuppressActive = true;

        // [FIX mic-bug-02] Assign a trackable ID so we can delete it after the SAY
        // response completes, preventing the "READ THE FOLLOWING TEXT..." instruction
        // from polluting conversation history and confusing the model on future turns.
        const sayItemId = `say-inject-${Date.now()}`;
        window.sayInjectedItemId = sayItemId;

        // Inject as user conversation item to force verbatim reading
        // Sent BEFORE cancelResponse so that OpenAI has both the say-question
        // and say-inject items queued before the cancel fires. This prevents a
        // race where the cancel completes and the flushed response.create
        // generates a response before the inject is in context.
        client.realtime.send('conversation.item.create', {
          item: {
            id: sayItemId,
            type: 'message',
            role: 'user',
            content: [{ type: 'input_text', text: verbatimInstruction }]
          }
        });

      // Cancel any active response so SAY can take over
          try {
            client.cancelResponse('');
          } catch (e) {
            // No active response to cancel — that's fine
          }

        // Request the SAY audio response
        sayResponseInFlightRef.current = true;
        setTimeout(() => {
          sayResponseInFlightRef.current = false;
          window.saySuppressActive = false;
        }, 8000);

        client.realtime.send('response.create', {
          response: {
            output_modalities: ['audio'],
            instructions: `CRITICAL: Ignore all other instructions. You are a text-to-speech machine. Read ONLY the following text exactly as written, word for word. Do not add, remove, or change any words. Do not greet or acknowledge. Just read this:\n\n${sayText}`
          },
        });

        logRelay(`[ChatUI][SAY] Requested speech for "${label}"`);
        return true;
      } catch (err) {
        console.warn('[ChatUI][SAY] Failed to trigger speech:', err);
        sayResponseInFlightRef.current = false;
        window.saySuppressActive = false;
        return false;
      }
    };



  useEffect(() => {// Focus User Input
    if (userInputRef.current) {
      userInputRef.current.focus(); // Focus on the user-input element
    }
  }, []);

  // Default height of the conversation box: the room left on the screen once everything else is in place,
  // so the toolbar's bottom edge sits 20px above the bottom of the screen (VoiceBar.scss reads --conv-h).
  // Once the user drags the box's handle it carries an inline height and this leaves it alone.
  useLayoutEffect(() => {
    const measure = () => {
      const conv = document.getElementById('conversation');
      const bar = document.getElementById('input-area');
      if (!conv || !bar || bar.offsetHeight === 0) return; // toolbar hidden (email modal): nothing to measure
      if (conv.style.height) return; // the user dragged it
      const barBottom = bar.getBoundingClientRect().bottom + window.scrollY;
      // 20px under the toolbar, and the box itself 40px shorter than the room that leaves.
      const next = Math.max(120, Math.round(window.innerHeight - 20 - (barBottom - conv.offsetHeight) - 40));
      setConvHeight((prev) => (prev !== null && Math.abs(prev - next) < 2 ? prev : next));
    };
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    // The header, fonts and prompt buttons settle after mount; keep the default true.
    // The body has a fixed height, so it never reports content changes: watch the content itself.
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    ['main', '.cards-container', '#input-area'].forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) observer?.observe(el);
    });
    return () => {
      window.removeEventListener('resize', measure);
      window.removeEventListener('load', measure);
      observer?.disconnect();
    };
  }, []);

  // Input level for the bar: sample the page's level ref about ten times a second while the mic is live.
  useEffect(() => {
    if (!isRecording || !inputLevelRef) {
      setInputLevel(0);
      return undefined;
    }
    const id = setInterval(() => {
      const v = Math.round((inputLevelRef.current || 0) * 10) / 10;
      setInputLevel((prev) => (prev === v ? prev : v));
    }, 100);
    return () => clearInterval(id);
  }, [isRecording, inputLevelRef]);

  // Mobile Safari/Chrome: suspend/resume mic cleanly on app background/foreground
  useEffect(() => {
    const attemptRestore = () => {
      if (isSessionExpiredLocked()) return;
      if (micRestoreInFlightRef.current || !micRestoreNeededRef.current) return;
      micRestoreInFlightRef.current = true;

      // Force a React re-mount of the mic button/image to avoid stale/broken nodes after tab restore
      setMicRenderKey((prev) => prev + 1);
      const wasRecording = wasRecordingOnHideRef.current;
      wasRecordingOnHideRef.current = false;

      // Try to re-establish websocket/mic readiness without auto-recording
      try {
        const connectPromise = clientRef?.current?.connect?.();
        if (connectPromise && typeof connectPromise.catch === 'function') {
          connectPromise.catch((err) => {
            if (err?.message === 'Already connected') {
              // Race: another path restored the connection first — safe to ignore
            } else {
              console.warn('[ChatUI] mic restore reconnect failed:', err?.message || err);
            }
          });
        }
      } catch (err) {
        console.warn('[ChatUI] mic restore reconnect failed (sync):', err?.message || err);
      } finally {
        micRestoreNeededRef.current = false;
        micRestoreInFlightRef.current = false;
      }
    };

    const handleVisibilityChange = () => {
      if (isSessionExpiredLocked()) return;
      if (document.visibilityState === 'hidden') {
        wasRecordingOnHideRef.current = isRecordingRef.current;
        micRestoreNeededRef.current = true;
        if (isRecordingRef.current && typeof stopRecording === 'function') {
          try {
            stopRecording();
          } catch (err) {
            console.warn('[ChatUI] stopRecording on hide failed:', err?.message || err);
          }
        }
      } else if (document.visibilityState === 'visible') {
        attemptRestore();
      }
    };

    const handlePageShow = () => attemptRestore();
    const handleFocus = () => attemptRestore();

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('focus', handleFocus);
    };
  }, [clientRef, stopRecording]);

const toReactStyle = (style) => {
  if (!style || typeof style !== 'object') return undefined;
  return Object.entries(style).reduce((acc, [key, value]) => {
    const camelKey = key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    acc[camelKey] = value;
    return acc;
  }, {});
};

const bodyStyle = useMemo(
  () => toReactStyle(selectedBotSettings?.bodyStyle),
  [selectedBotSettings?.bodyStyle]
);
const welcomeStyle = bodyStyle;
// The control row sits on the page background. Its icon PNGs are white and its labels were white, so on a light
// background (Guttman is white) they vanished: use black there, white on dark.
const pageBackground = selectedBotSettings?.containerStyle?.backgroundColor || settings?.containerStyle?.backgroundColor || '#9e9e9e7d';
const lightPage = isLightColor(pageBackground);
const controlIconStyle = lightPage ? { filter: 'invert(1)' } : undefined;
const controlLabelColor = lightPage ? 'black' : 'white';
const emailConfigToName = selectedBotSettings?.integration?.EmailConfig?.to_name?.trim?.() || '';
const emailConfigFromName = selectedBotSettings?.integration?.EmailConfig?.from_name?.trim?.() || '';
const cardStyle = useMemo(
  () => toReactStyle(selectedBotSettings?.buttonStyle),
  [selectedBotSettings?.buttonStyle]
);
const cardTextColor = selectedBotSettings?.buttonStyle?.color || undefined;

const promptButtonMax = Number(
  selectedBot?.promptbuttons ??
  iBots?.promptbuttons ??
  DEFAULT_PROMPT_BUTTON_MAX
) || DEFAULT_PROMPT_BUTTON_MAX;


  // ---- Voice bar: derived state and handlers -------------------------------------------------------
  // Hands-free has NO mic button: the mic is simply live and the status line says so.
  // Push-to-Talk shows the mic, which is the hold (or tap once) control.
  const speakingNow = inputLevel > 0.12;
  const ptt = micMode === 'ptt';
  const micVisual = micBlocked
    ? 'blocked'
    : isRecording
    ? pttHolding
      ? 'ptt-held'
      : 'ptt-open'
    : 'ptt-idle';
  const statusLabel = micBlocked
    ? 'Mic blocked. Allow it in browser settings.'
    : ptt
    ? isRecording
      ? pttHolding
        ? 'Release to send'
        : 'Mic is open. Tap to send.'
      : 'Hold the mic to talk, or tap once'
    : assistantSpeaking
    ? 'Assistant is speaking'
    : isRecording
    ? speakingNow
      ? 'Hearing you'
      : 'Listening. Just talk.'
    : 'Starting the microphone';
  // Ring around the mic (Push-to-Talk), inside the mic's own 60 pixel slot (never larger).
  const micHalo = micVisual === 'ptt-open' ? 56 : micVisual === 'ptt-held' ? 60 : 0;
  const BAR_SHAPE = [0.4, 0.7, 1, 0.6, 0.85, 0.5, 0.3];
  let statusBars = null;
  if (assistantSpeaking && !ptt && !micBlocked) {
    statusBars = (
      <span className="vbar-bars vbar-bars--bot" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => <i key={i} />)}
      </span>
    );
  } else if (isRecording && !micBlocked) {
    const count = speakingNow || micVisual === 'ptt-held' ? 7 : 5;
    statusBars = (
      <span className="vbar-bars" aria-hidden="true">
        {BAR_SHAPE.slice(0, count).map((shape, i) => (
          <i key={i} style={{ height: 5 + Math.round(inputLevel * 22 * shape) + (i % 2 ? 3 : 0) }} />
        ))}
      </span>
    );
  }

  // Grow the text input as the user types (up to 40% of the screen, the same cap as VoiceBar.scss;
  // the user can also drag its resize handle). React never sets
  // height on this uncontrolled textarea, so setting it here does not fight the reconciler.
  const autosizeInput = useCallback(() => {
    const el = userInputRef.current;
    if (!el) return;
    el.style.height = 'auto';
    const borders = el.offsetHeight - el.clientHeight; // border-box: scrollHeight leaves the borders out
    el.style.height = `${Math.min(el.scrollHeight + borders, Math.round(window.innerHeight * 0.4))}px`;
  }, []);

  // One place that sends typed text: used by Enter and by the send button.
  const submitTypedText = (inputElement, origin) => {
    const userInput = (inputElement?.value || '').trim();
    if (!userInput) return;
    // Typed input is NEVER suppressed (the transcript always shows under "You").
    // Media tags (video/link/speech) fire locally from text-input — English or Spanish —
    // and echo their own transcript; they intentionally do NOT reach the agent.
    // The language command switches the UI/session AND is echoed + sent.
    // Everything else is echoed and sent to the agent.
    const isCommand = tryHandleCommandMedia(userInput);
    const isMedia =
      !isCommand &&
      (tryHandleVideoModalMedia(userInput) ||
        tryHandleLinkMedia(userInput) ||
        tryHandleSpeechMedia(userInput));
    if (!isMedia) {
      onUserQuestion?.(userInput);
      setItems((prevItems) => [
        ...prevItems,
        { role: 'user', formatted: { text: userInput } },
      ]);
      try {
        clientRef.current.sendUserMessageContent([
          { type: 'input_text', text: userInput },
        ]);
      } catch (err) {
        console.warn(`[ChatUI] Text send failed (${origin}):`, err?.message);
      }
    }
    inputElement.value = '';
    setHasText(false);
    autosizeInput();
  };

  // Speaker toggle: unchanged behavior of the old stop-speech button.
  const handleSpeakerToggle = async () => {
    const wasMuted = isMuted; // capture state before toggle
    const shouldSendStop = stopButtonSendsStop && !wasMuted; // only when turning mute ON

    if (typeof toggleMute === 'function') {
      try {
        await toggleMute();
      } catch (err) {
        console.warn('[ChatUI] toggleMute failed:', err);
        // Even if mute toggle fails, still issue STOP if desired
      }
    }

    if (shouldSendStop) {
      try {
        await interruptPlayback();
        await handleStopClick({ preserveConversation: true });
      } catch (err) {
        console.warn('[ChatUI] STOP on stop-voice failed:', err);
      }
    } else if (typeof toggleMute !== 'function') {
      // Fallback to legacy behavior if no toggleMute was provided
      try {
        await handleStopClick({ preserveConversation: true });
      } catch (err) {
        console.warn('[ChatUI] STOP fallback failed:', err);
      }
    }
  };

  return (// jsx 
    <div id="root" data-component="ChatUI">
        {pdfModalSrc && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
            }}
            role="dialog"
            aria-modal="true"
          >
            <div
              style={{
                position: 'relative',
                width: '80vw',
                height: '80vh',
                background: '#fff',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 10px 40px rgba(0,0,0,0.35)',
              }}
            >
              <button
                onClick={() => {
                  setPdfModalSrc(null);
                  setPdfModalTitle('');
                }}
                aria-label="Close PDF"
                style={{
                  position: 'absolute',
                  top: '1px',
                  right: '14px',
                  fontSize: '28px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'blue',
                  zIndex: 10,
                }}
              >
                ×
              </button>
              <div style={{ padding: '10px 14px 0 14px', fontWeight: 600 }}>{pdfModalTitle}</div>
              <iframe
                src={pdfModalSrc}
                title={pdfModalTitle || 'PDF'}
                style={{ width: '100%', height: 'calc(100% - 42px)', border: 'none' }}
              />
            </div>
          </div>
        )}
        {videoModalSrc && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
            }}
            role="dialog"
            aria-modal="true"
          >
            <div
              style={{
                position: 'relative',
                width: '80vw',
                height: '80vh',
                background: '#fff',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 10px 40px rgba(0,0,0,0.35)',
              }}
            >
              <button
                onClick={() => {
                  setVideoModalSrc(null);
                  setVideoModalTitle('');
                }}
                aria-label="Close Video"
                style={{
                  position: 'absolute',
                  top: '1px',
                  right: '14px',
                  fontSize: '28px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'blue',
                  zIndex: 10,
                }}
              >
                ×
              </button>
              <div style={{ padding: '10px 14px 0 14px', fontWeight: 600 }}>{videoModalTitle}</div>
              <iframe
                src={videoModalSrc}
                title={videoModalTitle || 'Video'}
                style={{ width: '100%', height: 'calc(100% - 42px)', border: 'none' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        )}
        <Header />
      <main style={{ background: pageBackground }}>
        <div className="chat-container" style={{ background: selectedBotSettings?.chatStyle?.backgroundColor || settings?.chatStyle?.backgroundColor || '#9e9e9e7d', ...(convHeight ? { '--conv-h': `${convHeight}px` } : {}) }}>
          <div className="bot-avatar"></div>
          <div className="bot-container">
          <h1 id="botTitle" style={bodyStyle}>
            {user.firstname
              ? `Welcome ${user.firstname}!`
              : (() => {
                  // Use selectedBot prop directly (it is effectiveBot with translated title).
                  // Fall back to iBots lookup only if prop is unavailable — do NOT reassign
                  // the outer selectedBot variable or translated values will be overwritten.
                  if (selectedBot?.title) return selectedBot.title;
                  if (assistantId && iBots.length > 0) {
                    const _fallbackBot = iBots
                      .flatMap((group) => group.iBots)
                      .find((bot) => bot.botid === assistantId);
                    if (_fallbackBot) return _fallbackBot.title;
                    console.warn('No matching bot found for assistantId:', assistantId);
                    return 'Bot not found';
                  }
                  return 'Loading...';
                })()}
          </h1>


            <div id="ibook-thumb-div">
            {(() => {
              // Use a local const so the outer selectedBot prop is never overwritten.
              const _thumbBot = selectedBot || iBots
                .flatMap((group) => group.iBots)
                .find((bot) => bot.botid === assistantId);
                {/*}
                  // 🔹 Remove the existing `ibook-thumb` before rendering the new one
                    const thumbContainer = document.getElementById('ibook-thumb-div');
                    if (thumbContainer) {
                      const existingImage = document.getElementById('ibook-thumb');
                      if (existingImage && thumbContainer.contains(existingImage)) {
                        thumbContainer.removeChild(existingImage); // ✅ 
                      }
                    }
                if (_thumbBot?.settings?.showThumb && _thumbBot.thumbnail) {
                return (
                  <a href="/">
                    <img
                      id="ibook-thumb"
                      src={_thumbBot.thumbnail}
                      alt="iBook Thumbnail"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </a>
                  
                );
              }
              */}
              return null; // Render nothing if showThumb is false or no thumbnail exists
            })()}
          </div>
          
          {/* CARDS CONTAINER*/}            
         <div className="cards-container" style={{ background: selectedBotSettings?.chatStyle?.backgroundColor || settings?.chatStyle?.backgroundColor || '#551540' }}>
          <div className="cards">
            {selectedCategory && selectedSubCategory ? (
              selectedBot?.ontology &&
              selectedBot.ontology[selectedCategory] &&
              Array.isArray(selectedBot.ontology[selectedCategory][selectedSubCategory]) ? (
                selectedBot.ontology[selectedCategory][selectedSubCategory].map((message, index) => {
                  const firstLine = message?.split?.("\n")?.[0] || message;
                  const secondLine = message?.split?.("\n")?.[1];
                  const promptPayload = preservePromptMultiline ? message : firstLine;
                  return (
                  <div
                    key={`preset-${index + 1}`}
                    id={`card-${index + 1}`}
                    className="card"
                    style={cardStyle}
                    data-label={firstLine} // use only first line for bot + telemetry
                    role="button"
                    tabIndex={0}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      handleCardActivate(promptPayload);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleCardActivate(promptPayload);
                      }
                    }}
                  >
                    <span className="prompt-text">
                      <strong className='prompt-head' style={{ fontStyle: "bold", fontSize: "1.2em", color: cardTextColor }}>{firstLine}</strong>
                      {secondLine ? (
                        <>
                          <br />
                          <span className='prompt-subhead' style={{ fontStyle: "italic", fontSize: "1.1em", color: cardTextColor }}>
                            {secondLine}
                          </span>
                        </>
                      ) : null}
                    </span>
                  </div>
                )})
              ) : (
                <div>No sub-category array found to map over.</div>
              )
            ) : (
              [...Array(promptButtonMax)].map((_, index) => {
                const presetNumber = index + 1;
                const presetMessage = selectedBot?.presets?.[`${presetNumber}`] || "";
                const firstLine = presetMessage?.split?.("\n")?.[0] || presetMessage;
                const secondLine = presetMessage?.split?.("\n")?.[1];
                const promptPayload = preservePromptMultiline ? presetMessage : firstLine;
                const buttonText = firstLine || `Preset ${presetNumber}`;
                const iconDef = selectedBot?.iconSet?.[`${presetNumber}`];
                const Icon =
                  iconDef && (HeroSolid[iconDef.name] || HeroOutline[iconDef.name]) || null;

                // originalPreset: the English canonical text from iBot.json.
                // In Spanish mode selectedBot.presets is translated, but _originalPresets always
                // holds the English originals so the AI can recognise the canonical topic and fire
                // the required media button line.
                const origPresetMsg = selectedBot?._originalPresets?.[`${presetNumber}`] || presetMessage;
                const originalPayload = preservePromptMultiline ? origPresetMsg : (origPresetMsg?.split?.("\n")?.[0] || origPresetMsg);

                return (
                  <div// With HeroIcons
                    key={`preset-${presetNumber}`}
                      className="card"
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        textAlign: 'left',
                        ...(cardStyle || {}),
                      }}
                      data-label={firstLine}
                      role="button"
                      tabIndex={0}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleCardActivate(promptPayload, originalPayload);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleCardActivate(promptPayload, originalPayload);
                        }
                      }}
                    >
                      {Icon && (
                        <Icon
                          style={{
                            width: '30px',
                            height: '30px',
                            color: iconDef.color,
                            flexShrink: 0,
                          }}
                          aria-label={iconDef.label}
                        />
                      )}
                      <span
                        className="prompt-text"
                        style={{
                          display: 'inline-block',
                          textAlign: 'left',
                        lineHeight: '1.25',
                        verticalAlign: 'middle',
                        color: cardTextColor,
                      }}
                    >
                        <strong  className='prompt-head' style={{ fontStyle: "bold", fontSize: "1.3em", color: cardTextColor }}>{buttonText}</strong>
                        {secondLine ? (
                          <>
                            <br />
                            <span className='prompt-subHead' style={{ fontStyle: "normal", fontSize: "1.4em", color: cardTextColor }}>
                              {secondLine}
                            </span>
                          </>
                        ) : null}
                      </span>
                    </div>
                );
              })

            )}
          </div>
        </div>



          {/* END CARDS CONTAINER */}

          {/* 1. control table begin */}
          <div className="copy-button-container">
            <div className="control-row">
              <div className="welcome-text" id="welcome-text" style={{ ...welcomeStyle, fontSize: '1rem' }}>
                {selectedBot?.welcome || 'Ask me a question.'}
              </div>
              <div
                className="control-buttons"
                style={{
                  display: "",
                }}
              >
                {/*<button className="store-button" onClick={() => handleStoreChatHistory()} title="Store Chat History">
                  <img src={storeIconWhite} alt="Store" className="toolbar-image" />
                </button>*/}
                <button
                  className="copy-button"
                  data-label="Copy conversation"
                  onClick={() => copyConversationContent()}
                  title="Copy to Clipboard"
                    style={{
                      display:
                        selectedBotSettings?.containerStyle.copyContentButton === "true" 
                          ? "block"
                          : "none"
                    }}
                  >
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <img src={copyIconWhite} alt="copy" name='Copy Button' className="toolbar-image" data-label="Copy conversation icon" style={controlIconStyle} />
                    <span style={{ fontSize: "0.75rem", color: controlLabelColor, marginTop: "4px" }}>COPY</span>
                  </div>
                </button>

                <button
                  className="clear-session-button"
                  data-label="Clear conversation"
                  onClick={() => { notifySessionCleared('user_stop'); clearSession?.(); }}
                  title="Clear Conversation"
                  style={{
                      display:
                        selectedBotSettings?.containerStyle.deleteContentButton === "true" 
                          ? "block"
                          : "none"
                    }}
                  >
                  <img src={trashIconWhite} alt="clear"  name='Clear Button' className="toolbar-image" data-label="Clear conversation icon" style={controlIconStyle} />
                </button>

                 <button
                  className="email-content-button"
                  data-label="Avatar1"
                  onClick={() => {alert(`Hi, I'm ${selectedBot?.name}, ask me a Question.`) }}
                  title="Stewart"
                  style={{
                      display:
                        selectedBotSettings?.containerStyle.avatarButton === "true" 
                          ? "block"
                          : "none",
                    borderRadius: "50%",

                    background: "none",
                    textAlign: "center",
                    }}
                  >
                  <img src={selectedBot?.avatar} alt="clear"  name='AvatarButton' className="toolbar-image" data-label="Avatar1 Button" />
                  <span style={{ fontSize: "0.75rem", color: controlLabelColor, marginTop: "4px", display:"block" }}>
                      {selectedBot?.name}
                  </span>

                </button>

                {selectedBot?.avatar2 !== undefined && (
                <button
                  className="email-content-button"
                  data-label="Avatar2"
                  onClick={() => { window.location.href = selectedBot?.avatar2url; }}
                  title="Stewart"
                  style={{
                      display:

                        selectedBot?.avatar2 != "null" 
                          ? "block"
                          : "none",
                    borderRadius: "50%",

                    background: "none",
                    textAlign: "center",
                    }}
                  >
                  <img src={selectedBot?.avatar2} alt="Avatar 2"  name='Avatar2Button' className="toolbar-image" data-label="Avatar2 Button" />
                  <span style={{ fontSize: "0.75rem", color: controlLabelColor, marginTop: "4px", display:"block" }}>
                      {selectedBot?.avatar2name}
                  </span>

                </button>
                )}


                <button
                  className="email-content-button"
                  onClick={() => openEmailModal()}
                  title="Send Email"
                  style={{
                    display:
                      selectedBotSettings?.containerStyle.emailContentButton === "true"
                        ? "block"
                        : "none",
                    border: "none",
                    background: "none",
                    textAlign: "center",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <img src={emailIconWhite} alt="email"  name='Email Button' className="toolbar-image" data-label="Email Button" style={controlIconStyle} />

                    <span style={{ fontSize: "0.75rem", color: controlLabelColor, marginTop: "4px" }}>
                      {selectedBotSettings.botid === "asst_SRqG7nOQ8boguG6EeEPkpNlE" || selectedBotSettings.botid  === "asst_k6gkeaM6VZsbvOjfBNt6BFrK" ? "EMAIL SUSAN" : "EMAIL"}
                    </span>

                  </div>
                </button>

              </div>

            </div>
          </div>

          {/*Video Avatar */}
          {/*
          <div id="video-container" className="video-container">
              {selectedBot?.settings?.showAvatar ? (
                  selectedBot?.avatar ? (
                      <video muted loop id="circle-video">
                          <source src={selectedBot.avatar} type="video/mp4" />
                          Your browser does not support the video tag.
                      </video>
                  ) : (
                      <p>No avatar video available</p>
                  )
              ) : (
                  <StarFormation videoContainerRef={videoContainerRef} />
              )}
          </div>*/}
        
    {/* control table end  */}


    {/* conversation begin */} 
    <div id="conversation" className="conversation resizable" style={isConnected ? undefined : { pointerEvents: 'none', opacity: 0.5 }}>
      {items
        .filter(item => {
          const text = item.formatted?.text?.trim().toLowerCase();
          const isPing = text === '...';
          const isDot = text === '.';
          const isAutoIntro =
            item.role === 'user' &&
            text &&
            text.includes("let's get started!");

          let captureNameFlag = false
          //NOTE this is DEPR
          const isStandbyAssistantMessage =
            item.role === 'assistant' &&
            text &&
            (
              text.includes('standing by') ||
              text.includes("let me know when you're ready") ||
              text.includes("we can continue whenever you're") ||
              text.includes("take your time, i'm right here") ||
              text.includes('great to see you') ||
              text.includes("here whenever you're ready to continue.") ||
              text.includes("i'm still here") ||
              text.includes('just a reminder')
            );

      try {
         const chat1 = document.getElementById(`chat-text-item-1`)?.textContent?.trim() || '';

        if (chat1.includes("please tell me your name")) {        
          captureNameFlag = true
        }
  
        const chat2 =  document.getElementById(`chat-text-item-2`)?.textContent?.trim() || '';
 
        
        if (captureNameFlag === true && chat2 !== "") {
        let userReply = document.getElementById(`chat-text-item-2`)?.textContent ||"";// It's always item 2 (third chat item)

         
          // Parse Phrases
          if (
            userReply.includes("My name is") ||
            userReply.includes("I'm called") ||
            userReply.includes("You can call me") ||
            userReply.includes("It's") ||
            userReply.includes("I'm")
          ) {
            userReply = userReply
              .replace("My name is", "")
              .replace("I'm called", "")
              .replace("You can call me", "")
              .replace("It's", "")
              .replace("I'm", "")
              .trim();
            logRelay("Filtered name:", userReply);
          }
        
          if (userReply) {
              //logRelay("[USERNAME DETECTED] →", userReply);
              userInLineName = userReply 
              captureNameFlag = false;
              }
            }
          
      } catch (err) {
        console.error("Error parsing user name from conversation", err);
     }

      return !isPing && !isDot && !isStandbyAssistantMessage && !isAutoIntro;
      })

        //[Conversation Data] - Define     
        .map((item, index) => {
        const normalizeText = (s) =>
          String(s ?? "")
            .replace(/\r\n/g, "\n")
            .replace(/\r/g, "\n");

        let rawText = normalizeText(item.formatted?.text || item.formatted?.transcript || '');

        // 🔹 River islands Patch Normalize assistant spelling - Dell'Osso and Lathrop
        rawText = rawText
          .replace(/\bLay-thrup\b/g, "Lathrop")
          .replace(/\bLaythrup\b/g, "Lathrop")
          .replace(/\bDell-oh-zoh\b/g, "Dell'Osso")
          .replace(/\bDelosso\b/g, "Dell'Osso");

         // [Media] - define
        const mediaKeys = selectedBot?.media ? Object.keys(selectedBot.media) : [];

        // [canonicalMedia] If the bot defines a canonical-topic → media-key map, inject the
        // required key into the matching text when the AI omits it. This guarantees media tags
        // fire for every canonical topic regardless of AI consistency.
        const canonicalMedia = selectedBot?.canonicalMedia ?? {};
        const precedingUserText = (() => {
          for (let i = index - 1; i >= 0; i--) {
            if (items[i]?.role === 'user') {
              return (items[i].formatted?.text || items[i].formatted?.transcript || '').trim();
            }
          }
          return '';
        })();

        // [FIX SAY self-trigger loop] An assistant item that is itself the spoken response
        // to a SAY-mechanism injection (its preceding user item is a say-question-*/say-inject-*
        // item) often contains the triggering media key as a plain-text substring — e.g. the
        // "What You Can Build" canonical answer contains the phrase "what you can build".
        // Scanning that item for matchedMediaKeys treats it as a brand-new canonical-topic
        // mention on a fresh item index and re-fires requestSaySpeech, which produces another
        // matching item, ad infinitum. Skip media-key scanning for SAY-produced assistant items.
        const precedingUserItemId = (() => {
          for (let i = index - 1; i >= 0; i--) {
            if (items[i]?.role === 'user') {
              return items[i]?.id || '';
            }
          }
          return '';
        })();
        const isSayProducedResponse = item.role === 'assistant' &&
          (precedingUserItemId.startsWith('say-inject-') || precedingUserItemId.startsWith('say-question-'));

        const injectKey = (item.role === 'assistant' && precedingUserText)
          ? canonicalMedia[precedingUserText] || null
          : null;
        const rawTextForMatching = (injectKey && !rawText.toLowerCase().includes(injectKey.toLowerCase()))
          ? rawText + '\n' + injectKey
          : rawText;

        const matchedMediaKeys = (item.role === 'assistant' && !isSayProducedResponse)
          ? mediaKeys.filter(
              (key) => rawTextForMatching && rawTextForMatching.toLowerCase().includes(key.toLowerCase())
            )
          : [];

        /* ───────── TEMP DEBUG (remove me) — assistant media-tag matching ───────── */
        /*
        if (item.role === 'assistant' && rawText) {
          console.log(
            '%c[MEDIA MATCH]', 'color:#F4A300;font-weight:bold',
            '\n  assistant rawText:', JSON.stringify(rawText),
            '\n  available media keys (effectiveBot):', mediaKeys,
            '\n  matched keys:', matchedMediaKeys,
          );
        }
          */
        /* ──────────────────────────────────────────────────────────────────────── */

        const inlineMediaElements = [];

        /*HEY
        const parseMetadata = (metadataString = '') => {
          const attributes = {};
          metadataString.split(/\s+/).forEach((attr) => {
            const [key, value] = attr.split('=');
            if (key && value) {
              attributes[key.replace(/['"]/g, '')] = value.replace(/['"]/g, '');
            }
          });
          return attributes;
        };*/
        const parseMetadata = (metadataString = '') => {
          const attributes = {};
          const pairs = [];
          let current = '';
          let inQuotes = false;
          let quoteChar = null;

          for (let i = 0; i < metadataString.length; i++) {
            const char = metadataString[i];
            
            if ((char === '"' || char === "'") && (i === 0 || metadataString[i - 1] !== '\\')) {
              if (!inQuotes) {
                inQuotes = true;
                quoteChar = char;
              } else if (char === quoteChar) {
                inQuotes = false;
                quoteChar = null;
              }
            }
            
            if (char === ';' && !inQuotes) {
              if (current.trim()) pairs.push(current.trim());
              current = '';
            } else {
              current += char;
            }
          }
          
          if (current.trim()) pairs.push(current.trim());

          pairs.forEach((pair) => {
            const [key, ...rest] = pair.split('=');
            if (!key || !rest.length) return;
            const value = rest.join('=');
            attributes[key.trim()] = value.trim().replace(/^['"]|['"]$/g, '');
          });

          return attributes;
        };


        const parseStyleString = (styleString = '') => {// parse smediaType image and video style string into an object
          const style = {};
          styleString.split(';').forEach((rule) => {
            const [key, value] = rule.split(':');
            if (key && value) {
              style[key.trim()] = value.trim();
            }
          });
          return style;
        };

        if (matchedMediaKeys.length) {
          matchedMediaKeys.forEach((matchedMediaKey, mediaIndex) => {
            const matchedMediaData = selectedBot.media[matchedMediaKey];
            if (!matchedMediaData) return;

            const mediaAttributes = matchedMediaData?.metadata
              ? parseMetadata(matchedMediaData.metadata)
              : {};

            const mediaKeySanitized = matchedMediaKey.replace(/\s+/g, '-');
            const mediaType = matchedMediaData.type || 'image';

            // Command-type entries (language mode, etc.) are handled by onLanguageCommand,
            // not by the media renderer — skip silently to avoid spurious warnings.
            if (mediaType === 'command') return;

            // [i18n] In Spanish mode, effectiveBot.mediaKeys maps English key → Spanish label.
            // Use the Spanish label as the button display text so buttons render in the active language.
            const translatedMediaLabel = (() => {
              const t = selectedBot?.mediaKeys?.[matchedMediaKey];
              return (t && t !== matchedMediaKey) ? t : null;
            })();

            const mediaSrc =
              matchedMediaData.url ||
              matchedMediaData.src ||
              (mediaType === 'speech' ? 'say://inline' : null);

            if (!mediaSrc && mediaType !== 'speech' && mediaType !== 'query') {
              console.warn(`⚠️ No valid media source for key: ${matchedMediaKey}`, matchedMediaData);
              return;
            }

            const resolveTarget = (value = '') => {
              const normalized = value.trim().toLowerCase();
              const allowed = ['_self', '_blank', '_parent', '_top'];
              return allowed.includes(normalized) ? normalized : '_self';
            };
            const linkTarget = resolveTarget(mediaAttributes.target || matchedMediaData.target);
            const linkRel = linkTarget === '_blank' ? 'noopener noreferrer' : undefined;

            const parsedStyle = parseStyleString(mediaAttributes.style);
            let mediaElement = null;

            switch (mediaType) {
              case 'speech': {
                const sayText = matchedMediaData.say || matchedMediaData.text || '';
                const sayId = `${mediaKeySanitized}-${index}-${mediaIndex}`;

                if (!sayText) {
                  console.warn(`[ChatUI][SAY] Missing say text for ${matchedMediaKey}`);
                  break;
                }

                if (sayTriggeredRef.current.has(sayId)) {
                  break; // already requested for this render
                }

                requestAnimationFrame(async () => {
                  const ok = await requestSaySpeech(sayText, matchedMediaKey);
                  if (ok) {
                    sayTriggeredRef.current.add(sayId);
                  } else {
                    // allow retry on next render if it failed (e.g., client not ready)
                    sayTriggeredRef.current.delete(sayId);
                  }
                });
                break;
              }
              case 'email': {
                requestAnimationFrame(() => {
                  const target = document.getElementById(`chat-text-item-${index}`);
                  if (!target) return;

                  const wrapper = document.createElement('div');
                  wrapper.id = `ri-email-button-${index}`;
                  wrapper.setAttribute('data-name', 'chat-email-wrapper');
                  wrapper.style.textAlign = 'left';
                  wrapper.style.marginTop = '0.5em';

                  const button = document.createElement('button');
                  button.className = 'email-content-button';
                  button.title = 'Send Email';
                  button.setAttribute('data-name', 'chat-email-button');
                  button.onclick = () => openEmailModal();

                  const img = document.createElement('img');
                  img.src = emailIconBlack;
                  img.alt = 'email';
                  img.setAttribute('data-name', 'chat-email-icon');
                  img.className = 'toolbar-image';

                  button.appendChild(img);
                  wrapper.appendChild(button);
                  target.insertAdjacentElement('afterend', wrapper);
                });
                break;
              }

              case 'pdf': {
                const pdfTitle = mediaAttributes.title || 'PDF Document';
                const pdfStyle = {
                  width: mediaAttributes.width || '72vw',
                  height: mediaAttributes.height || '75vh',
                  border: '1px solid #ccc',
                  display: 'block',
                  marginTop: '1em',
                  ...parsedStyle,
                };

                // Build modal-safe src (avoid hash params that some browsers treat as inline)
                const fullSrc = mediaSrc;
                // Default: always open PDFs in modal unless explicitly disabled
                const openInModal =
                  String(mediaAttributes.modal || mediaAttributes.openInModal || 'true').toLowerCase() === 'true';
                const buttonText = mediaAttributes.buttonText || pdfTitle || 'Open PDF';
                if (openInModal) {
                  logRelay('[ChatUI][PDF] Render modal button for', fullSrc);
                  mediaElement = (
                    <button
                      key={`media-${mediaKeySanitized}-${mediaIndex}`}
                      type="button"
                      style={{ marginTop: '0.5em', padding: '6px 12px', cursor: 'pointer', pointerEvents: 'auto', ...(parsedStyle || {}) }}
                      onClick={() => {
                        logRelay('[ChatUI][PDF] Open modal for', fullSrc);
                        setPdfModalSrc(fullSrc);
                        setPdfModalTitle(pdfTitle);
                      }}
                      data-name={`chat-pdf-btn-${mediaIndex}`}
                      data-pdf-src={fullSrc}
                      data-pdf-title={pdfTitle}
                    >
                      {buttonText}
                    </button>
                  );
                } else {
                  mediaElement = (
                    <iframe
                      id={`pdf-viewer-${mediaKeySanitized}-${mediaIndex}`}
                      key={`media-${mediaKeySanitized}-${mediaIndex}`}
                      src={fullSrc}
                      style={pdfStyle}
                      title={pdfTitle}
                      data-name={`chat-pdf-${mediaKeySanitized}-${mediaIndex}`}
                    />
                  );
                }
                break;
              }

              case 'link': {
                requestAnimationFrame(() => {
                  const target = document.getElementById(`chat-text-item-${index}-div`);
                  if (!target) return;

                  const containerId = `ri-link-container-${mediaKeySanitized}-${index}-${mediaIndex}`;
                  if (document.getElementById(containerId)) return;

                  const linkTitle = translatedMediaLabel || mediaAttributes?.title || matchedMediaKey;
                  const linkStyle = mediaAttributes?.style || '';

                  const wrapper = document.createElement('div');
                  wrapper.id = containerId;
                  wrapper.setAttribute('data-name', `chat-link-wrapper-${mediaKeySanitized}-${index}-${mediaIndex}`);
                  wrapper.style.textAlign = 'left';
                  wrapper.style.marginTop = '0.5em';
                  wrapper.style.clear = 'both';

                  const a = document.createElement('a');
                  a.href = mediaSrc;
                  a.target = linkTarget;
                  if (linkRel) a.rel = linkRel;
                  a.textContent = linkTitle;
                  a.setAttribute('data-name', `Conversation Button ${linkTitle || mediaKeySanitized}`);

                  if (linkStyle) {
                    linkStyle.split(';').forEach((rule) => {
                      const [prop, val] = rule.split(':');
                      if (prop && val) a.style[prop.trim()] = val.trim();
                    });
                  }

                  wrapper.appendChild(a);
                  target.insertAdjacentElement('afterend', wrapper);
                });
                break;
              }

              case 'image': {
                requestAnimationFrame(() => {
                  const target = document.getElementById(`chat-text-item-${index}-div`);
                  if (!target) return;

                  const imageContainerId = `ri-image-container-${mediaKeySanitized}-${index}-${mediaIndex}`;
                  if (document.getElementById(imageContainerId)) return;

                  const wrapper = document.createElement('div');
                  wrapper.id = imageContainerId;
                  wrapper.setAttribute('data-name', `chat-image-wrapper-${mediaKeySanitized}`);
                  wrapper.style.textAlign = 'left';
                  wrapper.style.marginTop = '0.5em';
                  wrapper.style.clear = 'both';

                  const img = document.createElement('img');
                  img.src = mediaSrc;
                  img.alt = mediaAttributes.alt || '';
                  img.setAttribute('data-name', `Conversation Image ${mediaKeySanitized}`);
                  Object.assign(img.style, {
                    ...parsedStyle,
                    maxWidth: mediaAttributes.width || '88vw',
                    height: mediaAttributes.height || 'auto',
                    display: 'block',
                  });

                  wrapper.appendChild(img);
                  target.insertAdjacentElement('afterend', wrapper);
                });
                break;
              }
              // v1.051: imageLink – clickable image that opens mediaSrc in a new tab
              case 'imageLink': {
                requestAnimationFrame(() => {
                  const target = document.getElementById(`chat-text-item-${index}-div`);
                  if (!target) return;

                  const containerId = `ri-image-link-container-${mediaKeySanitized}-${index}-${mediaIndex}`;
                  if (document.getElementById(containerId)) return;

                  const wrapper = document.createElement('div');
                  wrapper.id = containerId;
                  wrapper.setAttribute('data-name', `chat-image-link-wrapper-${mediaKeySanitized}-${index}-${mediaIndex}`);
                  wrapper.style.textAlign = 'left';
                  wrapper.style.marginTop = '0.5em';
                  wrapper.style.clear = 'both';

                  // mediaSrc = link href
                  const a = document.createElement('a');
                  a.href = mediaSrc;
                  a.target = linkTarget;
                  if (linkRel) a.rel = linkRel;
                  a.setAttribute('data-name', `Conversation ImageLink ${mediaKeySanitized}`);

                  // image src comes from metadata (e.g. metadata.imageSrc or metadata.imgSrc)
                  const img = document.createElement('img');
                  const imageSrc =
                    mediaAttributes.imageSrc ||
                    mediaAttributes.imgSrc ||
                    mediaAttributes.src ||
                    '';

                  img.src = imageSrc;
                  img.alt = mediaAttributes.alt || '';
                  img.setAttribute('data-name', `Conversation ImageLink Image ${mediaKeySanitized}`);

                  Object.assign(img.style, {
                    ...parsedStyle,
                    maxWidth: mediaAttributes.width || '18vw', // your requested default
                    height: mediaAttributes.height || 'auto',
                    display: 'block',
                    cursor: 'pointer',
                  });

                  a.appendChild(img);
                  wrapper.appendChild(a);
                  target.insertAdjacentElement('afterend', wrapper);
                });
                break;
              }
              case 'video': {
                const videoPoster = mediaAttributes['data-thumbnail'] || '';
                const openInModal =
                  String(matchedMediaData.modal || mediaAttributes.modal || 'false').toLowerCase() === 'true';
                const renderMode = String(
                  matchedMediaData.render ||
                  mediaAttributes.render ||
                  'button'
                ).toLowerCase();
                const launchMode = String(
                  matchedMediaData.launch ||
                  mediaAttributes.launch ||
                  'click'
                ).toLowerCase();
                const legacyAutoOpen =
                  String(
                    matchedMediaData.autoOpenModal ||
                    mediaAttributes.autoOpenModal ||
                    matchedMediaData.autoOpen ||
                    mediaAttributes.autoOpen ||
                    'false'
                  ).toLowerCase() === 'true';
                const autoOpenModal =
                  openInModal &&
                  renderMode !== 'button' &&
                  (launchMode === 'auto' || legacyAutoOpen);
                const usePreviewMode = !openInModal && (renderMode === 'preview' || renderMode === 'thumbnail');
                const videoTitle = translatedMediaLabel || mediaAttributes.title || matchedMediaKey;
                const buttonText = translatedMediaLabel || mediaAttributes.buttonText || mediaAttributes.title || matchedMediaKey;
                const autoOpenId = `${mediaKeySanitized}-${index}-${mediaIndex}`;

                if (autoOpenModal) {
                  if (!autoOpenedVideoRef.current.has(autoOpenId)) {
                    requestAnimationFrame(() => {
                      setVideoModalSrc(mediaSrc);
                      setVideoModalTitle(videoTitle);
                      autoOpenedVideoRef.current.add(autoOpenId);
                    });
                  }
                  break;
                }

                if (openInModal) {
                  mediaElement = (
                    <button
                      key={`media-${mediaKeySanitized}-${mediaIndex}`}
                      type="button"
                      style={{ marginTop: '0.5em', padding: '6px 12px', cursor: 'pointer', pointerEvents: 'auto', ...(parsedStyle || {}) }}
                      onClick={() => {
                        setVideoModalSrc(mediaSrc);
                        setVideoModalTitle(videoTitle);
                      }}
                      data-name={`chat-video-btn-${mediaIndex}`}
                      data-video-modal-src={mediaSrc}
                      data-video-modal-title={videoTitle}
                    >
                      {buttonText}
                    </button>
                  );
                } else if (usePreviewMode) {
                  mediaElement = (
                    <a
                      id={`video-link-${mediaKeySanitized}-${mediaIndex}`}
                      key={`media-${mediaKeySanitized}-${mediaIndex}`}
                      href={mediaSrc}
                      target={linkTarget}
                      rel={linkRel}
                      data-name={`Conversation Video Link ${mediaKeySanitized}`}
                      style={{
                        border: '1px solid blue',
                        display: 'inline-block',
                        position: 'relative',
                      }}
                    >
                      <video
                        src={mediaSrc}
                        poster={videoPoster}
                        style={{
                          maxWidth: mediaAttributes.width || '88vw',
                          height: mediaAttributes.height || 'auto',
                          display: 'block',
                        }}
                        playsInline
                        loop
                        data-name={`Conversation Video ${mediaKeySanitized}`}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          width: '60px',
                          height: '60px',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pointerEvents: 'none',
                        }}
                      ></div>
                    </a>
                  );
                } else {
                  mediaElement = (
                    <a
                      id={`video-button-${mediaKeySanitized}-${mediaIndex}`}
                      key={`media-${mediaKeySanitized}-${mediaIndex}`}
                      href={mediaSrc}
                      target={linkTarget}
                      rel={linkRel}
                      data-name={`Conversation Video Button ${mediaKeySanitized}`}
                      style={{
                        marginTop: '0.5em',
                        padding: '6px 12px',
                        cursor: 'pointer',
                        pointerEvents: 'auto',
                        display: 'inline-block',
                        textDecoration: 'none',
                        ...(parsedStyle || {}),
                      }}
                    >
                      {buttonText}
                    </a>
                  );
                }
                break;
              }

              case 'embed': {
                const parsedStyle = mediaAttributes.style ? parseStyleString(mediaAttributes.style) : {};
                mediaElement = (
                  <div style={{ display: 'inline-block', height: mediaAttributes.height || '34vh' }}>
                    <video
                      id={`video-embed-${mediaKeySanitized}-${mediaIndex}`}
                      src={mediaSrc}
                      style={{
                        width: '100%',
                        height: mediaAttributes.height || '34vh',
                        display: 'block',
                        backgroundColor: '#fff',
                        ...parsedStyle,
                      }}
                      preload={mediaAttributes.preload || 'auto'}
                      poster={mediaAttributes.poster || undefined}
                      playsInline
                      controls={mediaAttributes.controls !== 'false'}
                      autoPlay={mediaAttributes.autoplay === 'true'}
                      muted={mediaAttributes.muted === 'true' || mediaAttributes.autoplay === 'true'}
                      data-name={`Conversation Embed Video ${mediaKeySanitized}`}
                      onClick={() => handleStopClick(clientRef.current)}
                    />
                  </div>
                );
                break;
              }

              case 'query': {
                const queryText = matchedMediaData.query || matchedMediaKey;
                const queryLabel =
                  translatedMediaLabel ||
                  mediaAttributes.buttonText ||
                  matchedMediaKey;
                mediaElement = (
                  <button
                    key={`query-${mediaKeySanitized}-${mediaIndex}`}
                    type="button"
                    style={{
                      display: 'block',
                      width: 'fit-content',
                      marginBottom: '10px',
                      cursor: 'pointer',
                      pointerEvents: 'auto',
                      ...(parsedStyle || {}),
                    }}
                    title={mediaAttributes.title || queryLabel}
                    data-query-text={queryText}
                    data-query-label={queryLabel}
                  >
                    {queryLabel}
                  </button>
                );
                break;
              }

              default:
                console.warn(`⚠️ Unsupported media type: ${mediaType}`);
            }

            if (mediaElement) {
              inlineMediaElements.push(mediaElement);
            }
          });
        }
        
        // Selected Bot Define
        const botName = selectedBot?.name ? `${selectedBot.name}: ` : "Agent";
        let userName = "You";
        if (user) {
          userName = user?.firstname 
            ? `${user.firstname[0].toUpperCase()}${user.firstname.slice(1)}: `
            : "You: ";
        }

        const textColor =
          item.role === 'assistant'
            ? 'black'
            : item.role === 'user' && item.formatted?.text
            ? 'gray'
            : '#666666';

        const stripRenderedMediaLines = (text, matchedKeys) => {
          if (!text || !matchedKeys.length) return text;

          const matchedKeySet = new Set(
            matchedKeys.map((key) => String(key).trim().toLowerCase()).filter(Boolean)
          );

          let removedMediaLine = false;
          let cleanedLines = normalizeText(text)
            .split('\n')
            .filter((line) => {
              const normalizedLine = line.trim().toLowerCase();
              if (!normalizedLine) return true;
              if (matchedKeySet.has(normalizedLine)) {
                removedMediaLine = true;
                return false;
              }
              return true;
            });

          if (removedMediaLine) {
            cleanedLines = cleanedLines.filter((line) => line.trim().toLowerCase() !== 'contents');
          }

          return cleanedLines
            .join('\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
        };

        const formattedTextSource =
          item.formatted?.text ??
          item.formatted?.transcript ??
          '';

        const formattedText =
          item.role === 'assistant'
            ? stripRenderedMediaLines(formattedTextSource, matchedMediaKeys)
            : formattedTextSource;

        const prefix = item.role === 'assistant'
          ? botName
          : item.role === 'user'
          ? userName
          : '';
        
        const mediaHtml = inlineMediaElements.length
          ? inlineMediaElements.map((el) => ReactDOMServer.renderToStaticMarkup(el)).join('')
          : '';
        const hasInlineMedia = mediaHtml.length > 0;

        // ✅ *** [Chat] [Media] Text element with clean multiline pattern without introducing unwanted spaces or <br>
        const mixedElement = (
              <div
                key={`text-${index}`}
                style={{ color: textColor }}
                dangerouslySetInnerHTML={{
                  __html: (
                    `<div id='media-container' style="display: ${hasInlineMedia ? 'block' : 'none'}; text-align: center; pointer-events: auto">` +
                      `${mediaHtml}` +
                    `</div>` +
                    `<div class='chat-text-item' id='chat-text-item-${index}-div' style="display: flex; align-items: flex-start; gap: 0.5em;" >` +
                      `<strong class='chat-role-item' id='chat-role-item-${index}' style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 25vw; flex-shrink: 0;">${prefix}</strong>` +
                    `<div class='chat-text-item' id='chat-text-item-${index}'><img class='chat-status-thinking' src="${statusThinking}" style="max-height: 3vh; display:none" /> ${formattedText.replace(/\n/g, '<br />')}</div></div>`
                  ),
                }}
              ></div>
            );


       //return mixedElement;

       

       return (
        <>
          {mixedElement}
          {/*<span id={`tracker-${index}`} data-index={index} style={{ display: 'none' }}></span>*/}
        </>
      );
      
      })}
    </div>
    {/* conversation end */}
      
    {/* 2. voice, text and speaker bar begin (design: docs/2.03/gds/images/voice-bar-states.png) */}
    <div id="input-area" className="vbar" data-component="VoiceBar" data-mic-mode={micMode}>
      <div className="vbar-status" data-name="Voice Status Line">
        {statusBars}
        <span className="vbar-status-label" aria-live="polite">{statusLabel}</span>
        {micBlocked && !ptt && (
          <button type="button" className="vbar-retry" onClick={() => onRetryMic()}>
            Try again
          </button>
        )}
        {/* Speaker toggle: same handler the old stop-speech button used */}
        <button
          id="stop-voice"
          type="button"
          className="vbar-speaker"
          title={isMuted ? 'Speaker is off. Tap to turn it on' : 'Speaker is on. Tap to turn it off'}
          aria-label={isMuted ? 'Turn the speaker on' : 'Turn the speaker off'}
          aria-pressed={isMuted}
          data-name="stop-speech-button"
          onClick={handleSpeakerToggle}
        >
          {isMuted ? <SpeakerOffIcon size={22} /> : <SpeakerIcon size={22} />}
        </button>
      </div>

      <div className="vbar-row">
        {ptt && (
          <div className="vbar-micslot">
            {micHalo > 0 && (
              <span className="vbar-halo" style={{ width: micHalo, height: micHalo }} aria-hidden="true" />
            )}
            <button
              id="toggle-voice"
              type="button"
              key={`mic-btn-${micRenderKey}`}
              data-name="Microphone Toggle Button"
              aria-label={statusLabel} // no title tooltip: it covered the status line, which already says this
              className={`vbar-mic vbar-mic--${micVisual}`}
              onContextMenu={(e) => e.preventDefault()}
              // Push-to-Talk: press and hold, or tap once to keep the mic open and tap again to send
              onPointerDown={(e) => {
                e.preventDefault();
                stopHandledRef.current = false;
                setPttHolding(true);
                if (isRecording) {
                  stopRecording(); // second tap of tap-to-talk: commit and send
                } else {
                  startRecording();
                }
              }}
              onPointerUp={(e) => {
                e.preventDefault();
                setPttHolding(false);
                if (stopHandledRef.current) return;
                stopHandledRef.current = true;
                stopRecording();
              }}
              onPointerCancel={(e) => {
                e.preventDefault();
                setPttHolding(false);
                if (stopHandledRef.current) return;
                stopHandledRef.current = true;
                stopRecording();
              }}
              onTouchEnd={(e) => {
                // Fallback for older WebViews
                e.preventDefault();
                setPttHolding(false);
                if (stopHandledRef.current) return;
                stopHandledRef.current = true;
                stopRecording();
              }}
              disabled={
                !iBots
                  .flatMap((group) => group.iBots)
                  .find((bot) => bot.botid === assistantId)?.endpoint.includes('realtime')
              }
            >
              {micVisual === 'blocked' ? <MicBlockedIcon size={28} /> : <MicIcon size={24} />}
            </button>
          </div>
        )}

        {/* User Input Textarea: always visible, grows as the user types */}
        <textarea
          id="user-input"
          className="vbar-input"
          data-name="Text Input Element"
          ref={userInputRef}
          rows={1}
          placeholder={micMode === 'hf' ? 'Message, or just talk' : 'Message'}
          aria-label="Message"
          onInput={(e) => {
            setHasText(e.target.value.trim() !== '');
            autosizeInput();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              submitTypedText(e.target, 'Enter');
            }
          }}
        ></textarea>

        {/* Submit Text Button */}
        <button
          id="submit-text"
          type="button"
          title="Send message"
          aria-label="Send message"
          className={`vbar-send${hasText ? ' is-ready' : ''}`}
          onClick={() => submitTypedText(document.getElementById('user-input'), 'Submit')}
        >
          <ArrowUpIcon size={22} />
        </button>
      </div>
    </div>

      {/* 2. input controls end */}
      
      
      {/* 3. content visuals begin */}
      {/*
      <div id="content-visuals" className="content-visuals">
          <div className="visualization">
             
              <canvas id="client-sound-wave" ref={clientCanvasRef} className="sound-wave"></canvas>

              <div id="video-container" className="video-container">
                  {selectedBot?.settings?.showAvatar ? (
                      selectedBot?.avatar ? (
                          <video muted loop id="circle-video">
                              <source src={selectedBot.avatar} type="video/mp4" />
                              Your browser does not support the video tag.
                          </video>
                      ) : (
                          <p>No avatar video available</p>
                      )
                  ) : (
                      <StarFormation videoContainerRef={videoContainerRef} />
                  )}
              </div>

              
              <canvas id="server-sound-wave" ref={serverCanvasRef} className="sound-wave"></canvas>
          </div>
      </div>
      */}
      {/* content visuals end */}
          
        {/* email modal */}
        {showEmailModal && (
          <div className="email-modal-overlay">
            <form id='email-form'>
            <div className="email-modal">
              <button className="email-modal-close" onClick={handleEmailCloseModal}>&times;</button>
              <h2 className="email-modal-title">Email Conversation</h2>
             
              {/* To and From show only when the agent's email settings give a name: no empty rows */}
              {emailConfigToName && (
                <div className="email-row">
                  <span>To:</span>
                  <div className="email-text">{emailConfigToName}</div>
                </div>
              )}
              {emailConfigFromName && (
                <div className="email-row">
                  <span>From:</span>
                  <div className="email-text">{emailConfigFromName}</div>
                </div>
              )}

            <div id='email-user'>
            <label htmlFor="emailFromName">Your Name</label>
            <input
                type="text"
                placeholder="Enter your name"
                defaultValue={(user?.firstname?.trim() || "")}
                id="emailFromName"
                onChange={(e) => setEmailFromName(e.target.value)}
                required
              />

              <label htmlFor="emailFrom">Your Email:</label>
              <input
                type="email"
                placeholder="Verify or Enter your email"
                defaultValue={user.email}
                id="emailFrom"
                onChange={(e) => setEmailFrom(e.target.value)}
                required
              />
              </div>

              
              <label
               htmlFor="emailSubject">Subject:</label>
              <input
                type="text"
                placeholder="Subject:"
                defaultValue={emailSubject}
                id="emailSubject"
                onChange={(e) => setEmailSubject(e.target.value)}
                required
              />

             <div id="emailLabel" style={{ fontSize: "0.85rem" }}>Body:</div>
              <div
              id="emailBody"
              className="conversation resizable"
              contentEditable={false}
              suppressContentEditableWarning={true}
              style={{ fontSize: "0.85rem" }}
              ref={(el) => {
                // EMAIL HANDLER  — run once to prevent re-build each render
                if (!el || el.dataset.initialized === "true") return;
                el.dataset.initialized = "true";

                const toMsg = selectedBotSettings?.integration?.EmailConfig?.emailMessage?.message || "";
                const source = document.getElementById("conversation");
                if (!source) return;

                const clone = source.cloneNode(true);

                const firstDiv = clone.querySelector("div:nth-child(1)");
                if (firstDiv) firstDiv.remove();
                const secondDiv = clone.querySelector("div:nth-child(1)");
                if (secondDiv) secondDiv.remove();

                const container = document.createElement("div");

                const header = document.createElement("div");
                header.innerText = toMsg;
                header.style.whiteSpace = "pre-wrap";
                header.style.marginBottom = "1em";

                const messageSection = document.createElement("div");
                const messageHeader = document.createElement("div");
                messageHeader.innerText = "Your message:";
                messageHeader.style.fontWeight = "bold";
                messageHeader.style.marginBottom = "0.5em";

                const messageBox = document.createElement("div");
                messageBox.contentEditable = "true";
                messageBox.style.width = "100%";
                messageBox.style.minHeight = "3em";
                messageBox.style.border = "1px solid #ccc";
                messageBox.style.padding = "6px";
                messageBox.style.marginBottom = "1.5em";
                messageBox.style.borderRadius = "4px";

   

                /* 🧠 preserve edits — store locally so re-renders keep text
                 messageBox.addEventListener("input", () => {
                 localStorage.setItem("draftEmailMessage", messageBox.innerText);
                //});

                const saved = localStorage.getItem("draftEmailMessage");
                if (saved) messageBox.innerText = saved;
                */
                // Add User footer to email - User name and Email:
                /*
                const userFooter = document.createElement("div");
                const emailFromName = document.getElementById("emailFromName").value;
                const emailFrom = document.getElementById("emailFrom").value;

                userFooter.style.marginTop = "1em";
                userFooter.style.fontSize = "0.85em";
                userFooter.style.color = "#555";
                userFooter.innerHTML = `<br/>
                  <strong>Sender:</strong> ${emailFromName}<br/>
                  <strong>Email:</strong>  ${emailFrom}
                `;
                
                messageSection.appendChild(userFooter);
                */
                messageSection.appendChild(messageHeader);
                messageSection.appendChild(messageBox);
                
                
                const transcriptHeader = document.createElement("div");
                transcriptHeader.innerText = "Transcript:";
                transcriptHeader.style.fontWeight = "bold";
                transcriptHeader.style.marginBottom = "0.5em";

                container.appendChild(header);
                container.appendChild(messageSection);
                container.appendChild(transcriptHeader);
                container.appendChild(clone);

                el.innerHTML = "";
                el.appendChild(container);
              }}
            />
             
              {emailErrorMessage && <p className="email-error-message">{emailErrorMessage}</p>}
              
              <div className="email-modal-actions">
                <button type="button" className="email-modal-cancel" data-label='Email Cancel Button' onClick={handleEmailCloseModal}>Cancel</button>
                <button type="button" className="email-modal-send" data-label="Email Send Button" onClick={sendEmailContent}>Send Email</button>
              </div>

              <div className="email-modal-footer">
                <a
                  className="email-modal-link"
                  data-label="Email Privacy Policy Link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://laurie7912.wixsite.com/ribusinesspark/privacy-policy"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </form>
        </div>
      )}  
        
       
       { /* controls */ }
           
          <div id="buttons-container" className="buttons-container" style={{display:"none"}}>
            <button
              id="loadThreads"
              className="load-threads"
              onClick={() => {
                const threadsLog = document.getElementById("threads-log");

                if (threadsLog.style.display === "none") {
                  threadsLog.style.display = "block";
                  document.getElementById("loadThreads").innerText = "Hide Threads";
                  
                  // Load threads if not already loaded
                  if (!threads || threads.length === 0) {
                    //handleLoadThreads();
                  }
                } else {
                  threadsLog.style.display = "none";
                  document.getElementById("loadThreads").innerText = "Load Threads";
                }
              }}
            >
              Load History
            </button>

            <button
              onClick={() => setShowEventsLog((prev) => !prev)}
              className="toggle-events-log"
            >
              {showEventsLog ? "Hide Events" : "Show Events"}
            </button>
          </div>
          

          {/* Threads Log (Below Buttons) */}
          <div id="threads-log" style={{ display: "block" }}>
            {loading && (
              <div style={{ color: "red", fontSize: "0.9em", fontWeight: "bold" }}>
                🔄 Fetching Conversation History...
              </div>
            )}
            {error && (
              <div style={{ color: "red", fontSize: "0.9em" }}>
                ⚠️ Error loading threads: <br />
                <span style={{ fontStyle: "italic" }}>{error}</span>
              </div>
            )}
             <pre id="threads-span">
              {threads
                ? JSON.stringify(
                    Object.values(
                      threads.reduce((grouped, thread) => {
                        const threadId = thread.thread_id || 'unknown-session';

                        if (!grouped[threadId]) {
                          grouped[threadId] = {
                            thread_id: threadId,
                            messages: [],
                          };
                        }

                        const rawText = thread.formatted?.text || thread.formatted?.transcript || '';
                        const text = rawText.trim().toLowerCase();

                        const isPing = text === '...';
                        const isDot = text === '.';
                        const isStop = text === 'stop';

                        const isStandby = // DEPR - Not implemented
                          text.includes('standing by') ||
                          text.includes("let me know when you\'re ready") ||
                          text.includes("we can continue whenever you\'re") ||
                          text.includes("take your time, i\'m right here") ||
                          text.includes('great to see you') ||
                          text.includes('great to have you here') ||
                          text.includes("i\'m here whenever you\'re ready to continue.") ||
                          text.includes("i\'m still here") ||
                          text.includes('just a reminder');

                        if (rawText && !isPing && !isDot && !isStop && !isStandby) {
                          grouped[threadId].messages.push(thread);
                        }

                        return grouped;
                      }, {})
                    ),
                    null,
                    2
                  )
                : ""}
            </pre>



          </div>

          {/* Events Log (Below Buttons) - Full Log
                  {Array.isArray(realtimeEvents)
          ? realtimeEvents.map((event, index) => (
              <pre id="event-span" key={index}>{JSON.stringify(event, null, 2)}</pre>
            ))
          : null}
          */}
          
          {/* Filtered Log - Speech */}
          <div
            ref={eventsScrollRef}
            className="events-log"
            id="events-log"
            style={{ display: showEventsLog ? "block" : "none" }}// or none
          >
            {Array.isArray(realtimeEvents)
            ? realtimeEvents
            // ChatUI.jsx — Events log filter (~line 2062)
            // [SDK] Filter realtime events to only show user input_text and completed assistant audio items.
            // Returns the boolean match condition.

                .filter((event) => {
                  const item = event?.event?.item;
                  const content = item?.content;
                  if (!item || !Array.isArray(content)) return false;

                // Return boolean — only show user text input or completed assistant audio
                return (
                  (item.role === "user" && content[0]?.type === "input_text") ||
                  (item.role === "assistant" && item.status === "completed" && content[0]?.type === "audio")
                );
                  
                })
                .map((event, index) => (
                  <pre id="event-span" key={index}>{JSON.stringify(event, null, 2)}</pre>
                ))
            : null}

          </div>
                
         {/* controls end */}

        </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

ChatUI.defaultProps = {
  botSettings: null,
  toggleMute: () => {},
  isMuted: false,
  micMode: 'hf',
};

export default ChatUI;
